(function($) {
    $.fn.equalHeights = function () {
        var tallest = null;
        $(this).each(function () {
            var outerHeight = $(this).outerHeight();
            if (outerHeight > tallest) {
                tallest = outerHeight;
            }
        });
        $(this).each(function (i) {
            var outerHeight = $(this).outerHeight();
            if (outerHeight < tallest) {
                $(this).height($(this).height() + (tallest - outerHeight));
            }
        });
        return this;
    };

    $.fn.equalColumnHeights = function (columns, padding) {
        var index = 0;
        var maxHeight = 0;
        var items = [columns];
        jQuery(this).each(function () {
            items[index] = jQuery(this);
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
            if (((index + 1) % columns) === 0) {
                for (var i = 0; i < columns; i++) {
                    items[i].height(maxHeight + padding);
                }
                index = 0;
                maxHeight = 0;
                for (var i = 0; i < columns; i++) {
                    items[i] = undefined;
                }
            }
            else {
                index++;
            }
        });
        if (maxHeight !== 0 || index !== 0) {
            for (var i = 0; i < columns; i++) {
                if (items[i] !== undefined) {
                    items[i].height(maxHeight + padding);
                }
            }
        }
        return jQuery(this);
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./assets/js/libs/jquery.equalHeights.js
// module id = jBmH
// module chunks = 3